export default __webpack_public_path__ + "static/media/Question.d624f313.svg";